<div [ngSwitch]="verticalType">
  <div *ngSwitchCase="verticalTypeEnum.ApartmentAssociation">
    <wl-naa-profile-type-edit [(profile)]="profile"></wl-naa-profile-type-edit>
  </div>
</div>
